import Vue from 'vue'
import Store from '../store'
import RoleType from '../../../Common/enums/RoleType'

const msalPlugin = {
    async signIn () {
      localStorage.setItem("lastUrlAtLogin", window.location.pathname)

      try {
        const msalInstance = new msal.PublicClientApplication(msalConfig)
        Vue.prototype.$msalInstance = msalInstance
        await msalInstance.handleRedirectPromise()
        const accounts = msalInstance.getAllAccounts()

        if (accounts.length === 0) {
            await msalInstance.loginRedirect()
        } else {
            const account = accounts[0]
            const claims = account.idTokenClaims
            if (!account || !claims || !claims.extension_Role || claims.extension_Role !== 'PRACTITIONER') {
              await this.signOut()
            } else {
              Store.commit('UserStore/SET_AUTH_DETAILS', account)
              Store.commit('UserStore/SET_ORGANISATION_ID', claims.extension_OrganisationId)
              Store.commit('UserStore/SET_CLAIMS', claims)
              Store.commit('UserStore/SET_USER_ROLE_TYPE', RoleType.PRACTITIONER)
              Store.commit('UserStore/SET_USER_ACCOUNT', account)

              // get token
              const scopes = process.env.VUE_APP_MSAL_SCOPES
              const scopesArray = scopes.split(',')
              const accessTokenRequest = {
                scopes: scopesArray,
                account: accounts[0]
              }

              const accessTokenResponse = await msalInstance.acquireTokenSilent(accessTokenRequest)
              Store.commit('UserStore/SET_ACCESS_TOKEN', accessTokenResponse.accessToken)
              Store.commit('UserStore/SET_USER_IS_AUTHENTICATED', true)
            }
        }
      }
      catch (ex) {
        await this.signOut()
      }
    },

    async signOut () {
      const msalInstance = new msal.PublicClientApplication(msalConfig)
      await msalInstance.handleRedirectPromise()

      const logoutRequest = {
        postLogoutRedirectUri: msalConfig.auth.redirectUri,
        mainWindowRedirectUri: msalConfig.auth.redirectUri
      }

      msalInstance.logoutRedirect(logoutRequest)
    }
}

const knownAuthorities = []
knownAuthorities.push(process.env.VUE_APP_MSAL_KNOWN_AUTHORITY.replace(/['"]+/g, ''))

let authority = process.env.VUE_APP_MSAL_LOGIN_AUTHORITY_SMS // default
let mfaPreference = localStorage.getItem("mfaPreference");
if (mfaPreference === "Email") {
  authority = process.env.VUE_APP_MSAL_LOGIN_AUTHORITY_Email
}
else if (mfaPreference === "SMS") {
  authority = process.env.VUE_APP_MSAL_LOGIN_AUTHORITY_SMS
}

const urlParams = new URLSearchParams(window.location.search);
const newMfaMethod = urlParams.get('mfaMethod');
if (newMfaMethod === "Email") {
  authority = process.env.VUE_APP_MSAL_LOGIN_AUTHORITY_Email
  localStorage.setItem("mfaPreference", "Email")
}
else if (newMfaMethod === "SMS") {
  authority = process.env.VUE_APP_MSAL_LOGIN_AUTHORITY_SMS
  localStorage.setItem("mfaPreference", "SMS")
}

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
    authority: authority,
    knownAuthorities: knownAuthorities,
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'sessionStorage',
    //cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  },
  system: {
    tokenRenewalOffsetSeconds: 120,
    loggerOptions: {
      logLevel: msal.LogLevel.Error,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case msal.LogLevel.Error:
            console.error(message)
            return
          case msal.LogLevel.Info:
            console.info(message)
            return
          case msal.LogLevel.Verbose:
            console.debug(message)
            return
          case msal.LogLevel.Warning:
            console.warn(message)
        }
      }
    }
  }
}

export default {
  install () {
    Vue.prototype.$msal = msalPlugin
  }
}
